<template>
	<popup-layout>
		<template slot="page-content">
			<slot name="page-content">
				<create-token showTokenGeneration="false" :showExpiration="true" @onExpirationChanged="onExpirationChanged" @onNamespaceChanged="onNamespaceChanged"></create-token>

				<div class="row grant-row">
					<div v-if="errorMessage" class="alert alert-danger" role="alert">
						{{ errorMessage }}
					</div>
					<button class="btn btn-danger" type="button" @click="authorizeApp()">
						<i class="fa fa-exclamation-circle fa-fw"></i> Grant Full Access</button>
				</div>
			</slot>
		</template>
	</popup-layout>
</template>

<script>
const logger = require("@/utils/logger");
const router = require("@/router");
const auth = require("@/utils/auth");
const appAuthorization = require("@/utils/app-authorization");
const namespaceService = require("@/utils/namespace-api");

export default {
  data() {
    return {
      namespace: null,
      expiration: null,
      errorMessage: null
    };
  },
  methods: {
    closeWindow() {
      window.close();
    },
    authorizeApp() {
      this.errorMessage = null;
      logger.log("Authorization begins for namespace " + this.namespace);

      if (!namespaceService.isValid(this.namespace)) return;

      var _this = this;
      appAuthorization.authorize(this.namespace, this.expiration, function(
        err
      ) {
        _this.errorMessage =
          "Failed to grant authorization for namespace " +
          _this.namespace +
          ".";
      });
    },
    onNamespaceChanged(namespace) {
      this.namespace = namespace;
    },
    onExpirationChanged(expiration) {
      this.expiration = expiration;
    }
  },
  mounted: function() {}
};
</script>

<style scoped>
.row {
  margin-bottom: 20px;
  margin-left: 0;
  margin-right: 0;
}
.grant-row {
  text-align: center;
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/AppAutoAuth.vue